import { Component, OnInit, Host } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { FirmwaresService } from "./firmwares.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { Firmware } from "../../api-models/Firmware";
import { FirmwaresMainComponent } from "./firmwares.main.component";

@Component({
    selector: "app-firmwares",
    templateUrl: "./firmwares.component.html",
    styleUrls: ["firmwares.component.scss"],
    standalone: false
})
export class FirmwaresComponent extends BaseMaterialDatatableComponent<Firmware> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: Firmware[] = [];

    constructor(
        private firmwaresService: FirmwaresService,
        private translateService: TranslateService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: FirmwaresMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: firmwaresService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_firmwares_list"
            },
            sortState: {
                active: "created",
                direction: "desc"
            },
            displayedColumns: ["name", "originalname", "productType", "published", "publishedBeta", "created", "updated", "actions"],
            listService: firmwaresService
        });

        this.UTCDATEFORMAT = this.firmwaresService.UTCDATEFORMAT;
    }

    // _dataTableTrigger() {
    //     return (dataTableParameters: DataTableParameters, callback: Function) => {
    //         // get api query parameters by datatable
    //         const queryParams = this.getApiQueryParamsByDataTable(dataTableParameters);

    //         this.subscriptions.push(
    //             this.firmwaresService.firmwares(queryParams).subscribe((result) => {
    //                 this.rows = result.list;

    //                 callback({
    //                     recordsTotal: result.total,
    //                     recordsFiltered: result.count,
    //                     data: []
    //                 });
    //             })
    //         );
    //     };
    // }

    addFirmware() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    editFirmware(id?: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    deleteFirmware(id?: string) {
        const initialState = {
            title: this.translateService.instant("firmwares.list.delete.title"),
            message: this.translateService.instant("firmwares.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        if (bsModalRef.content) {
            bsModalRef.content.confirmCallback = () => {
                if (!id) {
                    return;
                }

                this.subscriptions.push(
                    this.firmwaresService.deleteFirmware(id).subscribe((result) => {
                        this.alertService.addSuccess(this.translateService.instant("firmwares.list.delete.success"));
                        this.loadData();
                    })
                );
            };
        }
    }
}
